export const getSwapItemName = swap => {
  const nameItems = []
  if (swap.category) {
    if (swap.category.title) {
      nameItems.push(swap.category.title)
      switch (swap.category.requiredAdOptions) {
        case 'BrandModel':
          if (swap.brand && swap.brand.name) {
            nameItems.push(swap.brand.name)
          }
          if (swap.product && swap.product.model) {
            nameItems.push(swap.product.model)
          }
          break
        case 'BrandOnly':
          if (swap.brand && swap.brand.name) {
            nameItems.push(swap.brand.name)
          }
          if (swap.specificationValue1) {
            nameItems.push(swap.specificationValue1)
          }
          if (swap.specificationValue2) {
            nameItems.push(swap.specificationValue2)
          }
          break
        case null:
          if (swap.specificationValue1) {
            nameItems.push(swap.specificationValue1)
          }
          if (swap.specificationValue2) {
            nameItems.push(swap.specificationValue2)
          }
          break
      }
    }
  }
  return nameItems.join(' - ')
}
